import { useState } from 'react';

interface Project {
  id: number;
  image: string;
  title: string;
  category: string;
  location: string;
}

export default function GalleryGrid() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [lightboxImage, setLightboxImage] = useState<string | null>(null);

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'interior', name: 'Interior' },
    { id: 'exterior', name: 'Exterior' },
    { id: 'commercial', name: 'Commercial' },
    { id: 'residential', name: 'Residential' },
  ];

  const projects: Project[] = [
    {
      id: 1,
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fb767d49b02e648729ec0d2082df1ad62&methods=resize%2C600%2C5000',
      title: 'Modern Living Room Transformation',
      category: 'interior',
      location: 'Bushey',
    },
    {
      id: 2,
      image: 'https://public.readdy.ai/ai/img_res/d4697f3c0e6268e04f7a2f1700891bc7.jpg',
      title: 'Victorian House Exterior',
      category: 'exterior',
      location: 'Chorleywood',
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=elegant%20bedroom%20interior%20with%20soft%20warm%20beige%20walls%20white%20ceiling%20professional%20painting%20finish%20cozy%20atmosphere%20with%20natural%20light%20and%20modern%20decor%20showcasing%20high%20quality%20residential%20painting%20work&width=800&height=600&seq=gallery-project-003&orientation=landscape',
      title: 'Master Bedroom Makeover',
      category: 'residential',
      location: 'Pinner',
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=professional%20office%20space%20interior%20painting%20with%20sophisticated%20grey%20walls%20white%20trim%20modern%20business%20environment%20clean%20professional%20finish%20showing%20expert%20commercial%20painting%20craftsmanship%20and%20attention%20to%20detail&width=800&height=600&seq=gallery-project-004&orientation=landscape',
      title: 'Corporate Office Renovation',
      category: 'commercial',
      location: 'Gerrards Cross',
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=beautiful%20kitchen%20interior%20with%20freshly%20painted%20soft%20cream%20walls%20white%20cabinets%20modern%20appliances%20natural%20lighting%20showing%20professional%20residential%20painting%20work%20with%20smooth%20finish%20and%20perfect%20color%20coordination&width=800&height=600&seq=gallery-project-005&orientation=landscape',
      title: 'Contemporary Kitchen Refresh',
      category: 'interior',
      location: 'Northwood',
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=impressive%20commercial%20building%20exterior%20with%20professional%20painting%20fresh%20neutral%20tones%20clean%20architectural%20lines%20modern%20business%20property%20showcasing%20expert%20exterior%20painting%20work%20with%20weather%20resistant%20finish&width=800&height=600&seq=gallery-project-006&orientation=landscape',
      title: 'Commercial Building Facade',
      category: 'commercial',
      location: 'Radlett',
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=charming%20cottage%20exterior%20painting%20with%20warm%20terracotta%20walls%20white%20window%20frames%20traditional%20style%20residential%20property%20showing%20professional%20exterior%20painting%20craftsmanship%20with%20excellent%20coverage%20and%20durability&width=800&height=600&seq=gallery-project-007&orientation=landscape',
      title: 'Country Cottage Exterior',
      category: 'exterior',
      location: 'Rickmansworth',
    },
    {
      id: 8,
      image: 'https://readdy.ai/api/search-image?query=luxurious%20bathroom%20interior%20with%20soft%20grey%20blue%20walls%20white%20fixtures%20modern%20elegant%20design%20professional%20painting%20finish%20showing%20expert%20residential%20interior%20painting%20work%20with%20moisture%20resistant%20paint&width=800&height=600&seq=gallery-project-008&orientation=landscape',
      title: 'Luxury Bathroom Suite',
      category: 'residential',
      location: 'Bushey',
    },
    {
      id: 9,
      image: 'https://readdy.ai/api/search-image?query=spacious%20retail%20store%20interior%20with%20fresh%20white%20walls%20bright%20lighting%20modern%20commercial%20space%20professional%20painting%20finish%20showcasing%20expert%20commercial%20interior%20painting%20work%20with%20durable%20high%20traffic%20paint&width=800&height=600&seq=gallery-project-009&orientation=landscape',
      title: 'Retail Store Interior',
      category: 'commercial',
      location: 'Chorleywood',
    },
    {
      id: 10,
      image: 'https://readdy.ai/api/search-image?query=stunning%20home%20office%20interior%20with%20deep%20navy%20blue%20accent%20wall%20white%20trim%20modern%20workspace%20professional%20painting%20finish%20showing%20expert%20residential%20interior%20painting%20craftsmanship%20with%20bold%20color%20application&width=800&height=600&seq=gallery-project-010&orientation=landscape',
      title: 'Home Office Feature Wall',
      category: 'interior',
      location: 'Pinner',
    },
    {
      id: 11,
      image: 'https://readdy.ai/api/search-image?query=beautiful%20residential%20house%20exterior%20with%20soft%20grey%20walls%20white%20trim%20fresh%20professional%20painting%20finish%20charming%20property%20showcasing%20expert%20exterior%20painting%20work%20with%20weather%20protection%20and%20curb%20appeal&width=800&height=600&seq=gallery-project-011&orientation=landscape',
      title: 'Family Home Exterior',
      category: 'exterior',
      location: 'Gerrards Cross',
    },
    {
      id: 12,
      image: 'https://readdy.ai/api/search-image?query=cozy%20dining%20room%20interior%20with%20warm%20taupe%20walls%20white%20wainscoting%20elegant%20traditional%20style%20professional%20painting%20finish%20showing%20expert%20residential%20interior%20painting%20work%20with%20classic%20color%20palette&width=800&height=600&seq=gallery-project-012&orientation=landscape',
      title: 'Traditional Dining Room',
      category: 'residential',
      location: 'Northwood',
    },
    {
      id: 13,
      image: 'https://readdy.ai/api/search-image?query=modern%20restaurant%20interior%20with%20sophisticated%20charcoal%20walls%20ambient%20lighting%20contemporary%20commercial%20space%20professional%20painting%20finish%20showcasing%20expert%20commercial%20interior%20painting%20craftsmanship&width=800&height=600&seq=gallery-project-013&orientation=landscape',
      title: 'Restaurant Interior Design',
      category: 'commercial',
      location: 'Radlett',
    },
    {
      id: 14,
      image: 'https://readdy.ai/api/search-image?query=impressive%20period%20property%20exterior%20with%20cream%20colored%20walls%20traditional%20architecture%20professional%20painting%20finish%20beautiful%20residential%20building%20showing%20expert%20exterior%20painting%20work%20preserving%20historic%20character&width=800&height=600&seq=gallery-project-014&orientation=landscape',
      title: 'Period Property Restoration',
      category: 'exterior',
      location: 'Rickmansworth',
    },
    {
      id: 15,
      image: 'https://readdy.ai/api/search-image?query=bright%20cheerful%20nursery%20interior%20with%20soft%20pastel%20yellow%20walls%20white%20furniture%20playful%20atmosphere%20professional%20painting%20finish%20showing%20expert%20residential%20interior%20painting%20work%20with%20child%20safe%20paint&width=800&height=600&seq=gallery-project-015&orientation=landscape',
      title: 'Children\'s Nursery',
      category: 'interior',
      location: 'Bushey',
    },
    {
      id: 16,
      image: 'https://readdy.ai/api/search-image?query=elegant%20hallway%20interior%20with%20soft%20neutral%20walls%20white%20trim%20modern%20residential%20space%20professional%20painting%20finish%20showcasing%20expert%20interior%20painting%20craftsmanship%20with%20seamless%20color%20flow&width=800&height=600&seq=gallery-project-016&orientation=landscape',
      title: 'Entrance Hall Renovation',
      category: 'residential',
      location: 'Chorleywood',
    },
  ];

  const filteredProjects = selectedCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  return (
    <>
      <section className="py-20 px-6 bg-beige-50">
        <div className="max-w-7xl mx-auto">
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-amber-600 text-white shadow-lg'
                    : 'bg-white text-slate-700 hover:bg-beige-100 shadow-md border border-beige-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border border-beige-200"
                onClick={() => setLightboxImage(project.image)}
              >
                <div className="relative w-full h-80 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    title={`${project.title} - Professional Painting Project`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-3 backdrop-blur-sm">
                        <i className="ri-search-line text-2xl"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {project.title}
                  </h3>
                  <div className="flex items-center justify-between text-sm">
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-beige-100 text-amber-700 font-medium">
                      {categories.find(c => c.id === project.category)?.name}
                    </span>
                    <span className="flex items-center text-slate-600">
                      <i className="ri-map-pin-line mr-1"></i>
                      {project.location}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightboxImage(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors duration-300 cursor-pointer"
            onClick={() => setLightboxImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Project Detail"
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}